import type { PropsWithChildren } from "react";

import {
  LinearProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import SystemRowCollapsed from "./SystemRowCollapsed";

import type { OverviewSystem } from "./index";

type Props = {
  isLoading?: boolean;
  onSystemClicked: (displayName: string) => void;
  systems?: OverviewSystem[];
};

const MobileSystemTable = ({ systems, isLoading = false, onSystemClicked }: PropsWithChildren<Props>) => {
  const { t } = useTranslation("common");
  const hasSystems = (systems?.length ?? 0) > 0;

  return (
    <TableContainer sx={{ maxHeight: 300 }}>
      {isLoading && <LinearProgress />}
      <Table size="small" stickyHeader>
        <TableHead sx={{ backgroundColor: "grey.200" }}>
          <TableRow>
            <TableCell align="center" />
            <TableCell align="center">{t("system_name")}</TableCell>
            <TableCell align="center" />
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading && !hasSystems ? (
            <TableRow>
              <TableCell align="center" colSpan={3}>
                <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                  <Typography variant="body2">{t("loading_ellipses")}</Typography>
                </Stack>
              </TableCell>
            </TableRow>
          ) : (
            systems?.map((system) => (
              <SystemRowCollapsed key={system.id} system={system} onSystemClicked={onSystemClicked} />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MobileSystemTable;
